import Api from 'App/api'

export const getRenewalOffers = Api.get({
  controller: 'renewal_offers',
  action: 'listWithSettings',
})

export const getRenewalPersonalInfo = Api.get({
  controller: 'renewal_offers',
  action: 'getPersonalInfo',
})

export const getOccupantsInfo = Api.get({
  controller: 'renewal_offers',
  action: 'getOccupants',
})

export const getRenewalEmployers = Api.get({
  controller: 'renewal_offers',
  action: 'getEmployers',
})

export const getRenewalPetDetails = Api.get({
  controller: 'renewal_offers',
  action: 'getPets',
})

export const postRenewalCompleteRequest = Api.post({
  controller: 'renewal_offers',
  action: 'accept',
})

export const getRenewalRentedItems = Api.get({
  controller: 'renewal_offers',
  action: 'getAddOns',
})

export const getRenewalIncentives = Api.get({
  controller: 'renewal_offers',
  action: 'getIncentives',
})

export const createMtomInterval = Api.post({
  controller: 'renewal_offers',
  action: 'createMtomInterval',
})

export const getTransferFloorplans = Api.get({
  controller: 'renewal_offers',
  action: 'listTransferFloorPlans',
})

export const getListTransferUnitSearch = Api.get({
  controller: 'renewal_offers',
  action: 'listTransferUnitSearch',
})

export const postRenewalTransferRequest = Api.post({
  controller: 'renewal_offers',
  action: 'processTransferRequest',
})

export const getFloorplanLeaseTerms = Api.get({
  controller: 'renewal_offers',
  action: 'listLeaseTerms',
})

export const postRenewalrequest = Api.post({
  controller: 'renewal_offers',
  action: 'requestRenewal',
})

export const cancelRenewalRequest = Api.post({
  controller: 'renewal_offers',
  action: 'cancelRenewalRequest',
})

export const getRenewalRequestDetails = Api.get({
  controller: 'renewal_offers',
  action: 'getRenewalRequestDetails',
})

export const postRenewalSignal = Api.post({
  controller: 'renewal_offers',
  action: 'sendSignal',
})
